import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAccountsDefault = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10.797 4.444V6.4h.792a2.57 2.57 0 0 1 2.57 2.57v1.844h.52a.75.75 0 0 1 0 1.5h-3.627c-.59 0-1.07.479-1.07 1.07v2.172c0 .59.48 1.07 1.07 1.07h.037a.75.75 0 0 1 0 1.5h-.037a2.57 2.57 0 0 1-2.57-2.57v-1.899h-.94a2.57 2.57 0 0 1-2.57-2.57V9.126h-.79a2.57 2.57 0 0 1-2.57-2.57V4.444a2.57 2.57 0 0 1 2.57-2.57h4.046a2.57 2.57 0 0 1 2.57 2.57Zm-1.5 0V6.4H7.542c-.926 0-1.737.49-2.19 1.225h-1.17a1.07 1.07 0 0 1-1.07-1.07V4.444c0-.59.478-1.07 1.07-1.07h4.046c.59 0 1.07.48 1.07 1.07ZM11.59 7.9c.59 0 1.07.479 1.07 1.07v1.844h-1.607a2.57 2.57 0 0 0-2.259 1.343h-1.25a1.07 1.07 0 0 1-1.07-1.07V8.97c0-.591.479-1.07 1.07-1.07z"
      clipRule="evenodd"
    />
    <path d="m12.875 14.56 1.252 1.253 2.998-3a.699.699 0 0 1 .988.989l-3.491 3.493a.7.7 0 0 1-.988 0l-1.747-1.746a.699.699 0 0 1 .988-.988Z" />
  </svg>
);
export default SvgAccountsDefault;
